import * as yup from "yup";

import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

export const EditEmailFormValidationSchema = yup.object({
    newEmail: RHFUserValidationRules.checkExistingEmail,
    password: RHFUserValidationRules.password
});

export type EditEmailFormValues = yup.InferType<
    typeof EditEmailFormValidationSchema
>;
